export const memberStatus = [
  {
    checkboxValue: false,
    daysInput: true,
    helpInfo: true,
    info: "Once Inactivated, the member can no longer access the member website or app, log into networked equipment to the FitLinxx System, and show up on active member reports.",
    key: "days_to_change_status_to_inactive",
    label:
      "Number of days without a workout session that a member's status will be changed to Inactive",
    value: "",
  },
  {
    checkboxValue: false,
    daysInput: true,
    helpInfo: true,
    info: "Once Terminated, the member can no longer access the member website or app, log into networked equipment to the FitLinxx System, and show up on active member reports.",
    key: "days_to_change_status_to_terminated",
    label:
      "Number of days without a workout session that a member’s status will be changed to Terminated Facility",
    value: "",
  },
  {
    checkboxValue: false,
    daysInput: true,
    helpInfo: true,
    info: "Member Status will automatically change to Terminated after the set number of Trial days.",
    key: "free_trial_days",
    label: "Free Trial Days",
    value: "",
  },
  {
    daysInput: false,
    helpInfo: true,
    info: "if checked, it will expunge the FitLinxx IDs of members who have a Member Status of Terminated Facility or Terminated FitLinxx so the number will become available for reuse. ",
    key: "reclaim_terminated_id",
    label: "Reclaim Terminated FitLinxx ID’s",
    value: false,
  },
  // {
  //   daysInput: false,
  //   helpInfo: true,
  //   info: "This feature will not record Exercise Readiness, Health Conditions, Contacts, or Interests.",
  //   key: "express_member_setup_on",
  //   label: "Express Member Set Up is On",
  //   value: false,
  // },
  {
    daysInput: false,
    helpInfo: false,
    info: "",
    key: "exercise_readiness_tab_on",
    label: "Exercise Readiness Tab is On",
    value: false,
  },
  {
    daysInput: false,
    helpInfo: false,
    info: "Message",
    key: "health_conditions_tab_on",
    label: "Health Conditions Tab is On",
    value: false,
  },
  {
    daysInput: false,
    helpInfo: false,
    info: "",
    key: "specify_interests_tab_on",
    label: "Specify Interests Tab is On",
    value: false,
  },
  {
    daysInput: false,
    helpInfo: true,
    info: "Can be customized for individual member during member set up.",
    key: "include_new_members_in_ranking_report_by_default",
    label: "Include New Members in Ranking reports by Default",
    value: false,
  },
];

export const trainingPartner = [
  {
    helpInfo: false,
    info: "",
    key: "allow_new_members_to_change_settings_by_default",
    label: "Allow New members to change settings by default",
    value: false,
  },
  {
    helpInfo: true,
    info: "Can be customized for individual member during member set up.",
    key: "allow_members_to_change_weight_targets_by_default",
    label: "Allow Members to Change Weight Target by Default",
    value: false,
  },
];

export const emailControl = [
  {
    helpInfo: false,
    info: "",
    key: "allow_broadcast_messaged_to_be_emailed_to_members",
    label: "Allow Broadcast Messages to be e-mailed to Members",
    value: false,
  },
];

export const emailDestination = [
  {
    helpInfo: false,
    info: "",
    key: "by_default_send_messages_to_online_account_and_email_address",
    label: "Both the member’s ActiveLinxx online account and email address",
    value: false,
  },
  {
    helpInfo: false,
    info: "",
    key: "by_default_send_messages_to_members_only",
    label: "Member’s email address",
    value: false,
  },
  {
    helpInfo: false,
    info: "",
    key: "by_default_send_messages_to_online_account_only",
    label: "Member’s ActiveLinxx online account",
    value: false,
  },
];
